import { render, staticRenderFns } from "./zhuanyequnScrollItem.vue?vue&type=template&id=2959cf7d"
import script from "./zhuanyequnScrollItem.vue?vue&type=script&lang=js"
export * from "./zhuanyequnScrollItem.vue?vue&type=script&lang=js"
import style0 from "./zhuanyequnScrollItem.vue?vue&type=style&index=0&id=2959cf7d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports